export { default } from './DayCardMobile';
